import Gikam from '../core/gikam-core.js';
import jQuery from 'jquery';
export default class Base {
    constructor() { }


    initialize(param, defaultOptions) {
        this.options = Gikam.deepExtend(defaultOptions, param);
        this.registerListeners();
        return this;
    }

    registerListeners() {
        let _this = this;
        this.listeners && Gikam.each(this.options, function (property, value) {
            let name = Gikam.toInitialLowerCase(property.replace('on', ''));
            _this.listeners[name] && (_this.listeners[name] = value);
        });
    }

    trigger(event) {
        if (!this.listeners) return;
        let listener = this.listeners[event];
        if (listener) {
            return listener.apply(this, Array.prototype.slice.apply(arguments, [1]))
        }
    }

    bindInstance(dom) {
        return jQuery(dom).data('gikam.comp.data', this)
    }
}



